<template>
  <div class="page project-settings-container">
    <LayoutContainer>
      <div class="page-header project-settings-header" v-if="currentProject">
        <h1 class="title">ตั้งค่าโปรเจกต์</h1>
      </div>
      <Tab>
        <router-link
          :to="`/${this.teamName}/projects/${this.projectId}/settings/general`"
          class="tab-item"
        >
          <div class="tab-item-menu">General</div>
        </router-link>
        <router-link
          :to="`/${this.teamName}/projects/${this.projectId}/settings/setup`"
          class="tab-item"
        >
          <div class="tab-item-menu">Setup</div>
        </router-link>
        <router-link
          :to="`/${this.teamName}/projects/${this.projectId}/settings/advanced`"
          class="tab-item"
        >
          <div class="tab-item-menu">Advanced</div>
        </router-link>
      </Tab>
      <div class="page-content" v-if="currentProject">
        <router-view :project="currentProject" />
      </div>
    </LayoutContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayoutContainer from '@/layout/LayoutContainer.vue';
import Tab from '@/components/Tab.vue';

export default {
  components: {
    LayoutContainer,
    Tab,
  },
  computed: {
    ...mapGetters(['currentProject']),
    teamName() {
      return this.$route.params.teamName;
    },
    projectId() {
      return this.$route.params.projectId;
    },
    tabs() {
      const tab = [
        {
          action: `/${this.teamName}/projects/${this.projectId}/settings/general`,
          label: 'General',
          isActive: false,
        },
        {
          action: `/${this.teamName}/projects/${this.projectId}/settings/setup`,
          label: 'Setup',
          isActive: false,
        },
        {
          action: `/${this.teamName}/projects/${this.projectId}/settings/advanced`,
          label: 'Advanced',
          isActive: false,
        },
      ];
      return tab;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
@import '@/assets/scss/themes/components/tab.scss';
</style>
